import { edmCampaign } from '@bingads-webui/edm-campaign';

export const upgradeCampaignsToPMaxCall = ({
  cid,
  aid,
  payload,
}) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Campaigns['Default.UpgradeCampaignsToPMax']
  .$makeCall({
    payload,
  })
  .toPromise();

export const fetchCampaignUpgradeData = ({
  cid,
  aid,
  params,
  payload,
}) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Campaigns['Default.GridData']
  .$makeCall({
    query: {
      top: params.$top || 20,
      count: params.$count || true,
      filter: { where: params.$filter },
    },
    payload,
  })
  .toPromise();
